import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IAtxDropdown } from '../interfaces';

@Component({
    selector: 'atx-dropdown',
    template: `<ng-container dropdown
              (onShown)="fireShown.emit($event)"
              (onHidden)="fireHidden.emit($event)"
              (isOpenChange)="fireChange.emit($event)">
    <ng-content dropdownToggle></ng-content>

    <ul *dropdownMenu>
        <li role="menuitem"
            *ngFor="let element of model">
            <a class="dropdown-item">
                {{ element?.label }}
            </a>
        </li>
    </ul>
</ng-container>
`,
    styles: [``],
})

export class AtxDropdownComponent {
    @Input() public readonly model: IAtxDropdown;

    @Output('onShown') public readonly fireShown: EventEmitter<void> = new EventEmitter();
    @Output('onHidden') public readonly fireHidden: EventEmitter<void> = new EventEmitter();
    @Output('onChange') public readonly fireChange: EventEmitter<void> = new EventEmitter();
}
